import React, { useState } from 'react';
import '../styles/StartupLanding.css';

const StartupLanding = () => {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('idle');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            setMessage('Please enter a valid email');
            setStatus('error');
            return;
        }
        setStatus('loading');
        try {
            const response = await fetch('https://formspree.io/f/myzbbaqj', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({
                    email: email,
                    _subject: "New MoveFlair Waitlist Signup",
                    message: "New moving service waitlist signup",
                    name: "MoveFlair Waitlist Form",
                    _replyto: email,
                    submission: {
                        timestamp: new Date().toISOString(),
                        source: 'MoveFlair Landing Page',
                        location: window.location.href,
                        referrer: document.referrer || 'Direct'
                    }
                })
            });
            
            if (response.ok) {
                setStatus('success');
                setMessage("You're on the waitlist! We'll keep you updated.");
                setEmail('');
                console.log('Form submitted successfully');
            } else {
                const error = await response.text();
                console.error('Form submission error:', error);
                throw new Error('Failed to submit');
            }
        } catch (err) {
            console.error('Submission error:', err);
            setStatus('error');
            setMessage('Something went wrong. Please try again.');
        }
    };

    return (
        <div className="startup-container">
            <main className="hero-section">
                <div className="content-wrapper">
                    <h1>Moving, Simplified.</h1>
                    <p className="subtitle">
                        Skip the quotes and phone calls — book your movers instantly when we launch near you.
                    </p>

                    <form className="waitlist-form" onSubmit={handleSubmit}>
                        <input
                            type="email"
                            name="email"
                            placeholder="Your email address"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="email-input"
                            disabled={status === 'loading'}
                        />
                        <button
                            type="submit"
                            className="join-button"
                            disabled={status === 'loading'}
                        >
                            {status === 'loading' ? '...' : 'Get Early Access →'}
                        </button>
                    </form>
                    {message && (
                        <div className={`message ${status}`}>
                            {message}
                        </div>
                    )}

                    <div className="features">
                        <span>⚡️ Instant Booking</span>
                        <span>💰 Transparent Pricing</span>
                        <span>✨ Verified Local Movers</span>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default StartupLanding;